let activeAccessToken: { token: string; expiresAt: number } | undefined;

export function setActiveAccessToken(token: string | undefined, expiresAt?: number) {
  if (token && typeof expiresAt === "number" && Number.isFinite(expiresAt)) {
    activeAccessToken = { token, expiresAt };
  } else {
    activeAccessToken = undefined;
  }
}

export function getActiveAccessToken() {
  if (activeAccessToken && Date.now() >= activeAccessToken.expiresAt) {
    activeAccessToken = undefined;
  }
  return activeAccessToken?.token;
}
